<template>
	<div>
		<FormulateInput
			v-if="showPersonalData"
			class="col-12 px-0 mb-3 small"
			:class="additionalClasses"
			type="checkbox"
			name="personalData"
			validation="required"
			:validation-messages="{
				required: `${$t('agreementRequired')}`
			}"
			data-action="panels-agreementinput-personal-data-processing-agreement"
		>
			<template #label="{ id }">
				<label :for="id" class="ml-2">
					{{ $t('submitAgreement') }}

					<a
						:href="personalDataLink"
						target="_blank"
					>
						{{ $t('personalDataProcessing') }} *
					</a>
				</label>
			</template>
		</FormulateInput>
	</div>
</template>

<script>
import agreementsMixin from '~/mixins/agreementsMixin';

export default {
	name: 'AgreementInput',
	mixins: [
		agreementsMixin,
	],
	props: {
		additionalClasses: {
			type: String,
			default: '',
		},
	},
	computed: {
		personalDataLink() {
			return `https://www.skolkovo.ru/static/personaldata_${this.$i18n.locale === 'ru' ? 'rus' : 'eng'}.html`;
		},
	},
};
</script>

<style scoped>

</style>
